import Response from "./Response.js"
import { db } from '../db';
import Events from "./Events";
import PlayTesterUser from "./PlayTesterUser.js";
import UserObject from "./UserObject.js";
/*
  Gathers data and returns an exportable CSV of the survey results. 
*/


async function exportCSVBySurvey(surveyID, surveyQuestions) {
    return new Promise(async(resolve, reject) => {
        try {
            // First get all completed responses for the survey using surveyID
            const { data: surveyResponses } = await Response.getCompletedResponses(surveyID);
            const csvRows = [];

            // Add header row containing everything stored for each user. 

            const header = [
                "Tester ID",
                "Name",
                "Email",
                "Age",
                "Gender",
                "Profile",
                "Platform",
                "Genre",
                "Behavior",
                "Purchasing Behavior",
            ];

            // const header = [
            //     "Tester ID",
            //     "Name",
            //     "Email",
            // ];


            // Iterate over each of the questions within the survey and add the title to the header, joined with a comma
            const questionTitles = surveyQuestions.map((question) => `"${question.content.title}"`);
            header.push(...questionTitles);
            csvRows.push(header.join(","));


            //Now moving on to each tester, get their profile information and add it to a row. Each row will contain a singular tester's
            //profile information and responses to the survey questions
            //There should be as many rows as we have responses from testers


            for (const response of surveyResponses) {
                const testerInfo = await PlayTesterUser.getPlayTesterProfile(response.testerID);
                const userInfo = await UserObject.getProfile(response.testerID);
                const testerRow = [
                    response.testerID,
                    userInfo.data.userName,
                    userInfo.data.email,
                    testerInfo.data.age,
                    testerInfo.data.gender,
                    testerInfo.data.profile.join("&"),
                    testerInfo.data.platform.join("&"),
                    testerInfo.data.genre.join("&"),
                    testerInfo.data.behavior.join("&"),
                    testerInfo.data.purchasingBehavior.join("&"),
                ];

                // For each tester, we will iterate over all their responses and add it to the row, under the respective question

                const responseValues = response.responses.map((q, qIndex) => {
                    return replaceIndexWithText(q, surveyQuestions[qIndex]);
                });
                testerRow.push(...responseValues);


                csvRows.push(testerRow.join(","));
            }

            // Now we should have a header, and a row for each tester, with their profile information and responses
            // We will join each row with a new line and return the CSV text, which is then exported in the Results.vue component
            const csvText = csvRows.join("\r\n");
            Events.logEvent("results.exported", {
                surveyId: surveyID,
                responses: surveyResponses ? surveyResponses.length : null,
            });
            resolve({ success: true, data: csvText });
        } catch (error) {
            reject({ success: false, error: error.message || "Error exporting CSV" });
        }
    });
}

//Helper function that gets the tester information from the PlayTester collection
async function getTesterInfo(testerID) {
    return new Promise((resolve, reject) => {
        db.collection("PlayTester")
            .doc(testerID)
            .get()
            .then((doc) => {
                if (doc.exists) {
                    const testerData = doc.data();
                    resolve({
                        testerID: testerData.testerID,
                        age: testerData.age,
                        gender: testerData.gender,
                        profile: testerData.profile,
                        platform: testerData.platform,
                        genre: testerData.genre,
                        behavior: testerData.behavior,
                        purchasingBehavior: testerData.purchasingBehavior,
                    });
                } else {
                    reject({ success: false, error: "Tester not found" });
                }
            })
            .catch((error) => {
                reject({ success: false, error: error.message || "Error fetching tester information" });
            });
    });
}

//This is a helper function that helps format each response value based on the question type
//Currently, the responses are stored as indices rather than the string value
function replaceIndexWithText(response, question) {

    //If multiple choice, we replace the index with the text of the selected option
    if (question.qType === "multi-choice") {
        const selectedOption = question.content.options[response.value];
        return selectedOption ? selectedOption.text : "";
    }

    //If dropdown, we replace the index with the text of the selected option
    if (question.qType === "dropdown") {
        return question.content.options[response.value] || "";
    }

    //If multi-select, we replace the indices with the texts of the selected options, joined with an ampersand
    if (question.qType === "multi-select") {
        return response.value.map(index => question.content.options[index]).join("&");
    }

    //Finally for linear scale and text answers, we just return the value, as they are already correctly formatted
    return response.value;
}
export default {
    exportCSVBySurvey,
};



// WEBPACK FOOTER //
// ./src/Firestore/ExportSurveyAnalytics.js